import PropTypes from "prop-types";
import { useRef } from "react";
import s from "./EventTabs.module.css";

export const LIVE_TAB_ID = "events-tab-live";
export const OFF_TAB_ID = "events-tab-off";
export const PANEL_ID = "events-panel";

export default function EventTabs({ tab, setTab, liveCount, offCount }) {
  const tabRefs = useRef({});

  const handleKeyDown = (e) => {
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
    e.preventDefault();
    const nextTab = tab === "live" ? "offcamera" : "live";
    setTab(nextTab);
    const refKey = nextTab === "live" ? LIVE_TAB_ID : OFF_TAB_ID;
    tabRefs.current[refKey]?.focus();
  };

  const renderTab = (id, value, label) => (
    <button
      type="button"
      role="tab"
      id={id}
      className={s.tab}
      aria-selected={tab === value}
      aria-controls={PANEL_ID}
      tabIndex={tab === value ? 0 : -1}
      ref={(el) => {
        tabRefs.current[id] = el;
      }}
      onClick={() => setTab(value)}
    >
      {label}
    </button>
  );

  return (
    <div
      className={s.tabs}
      role="tablist"
      aria-label="Event categories"
      onKeyDown={handleKeyDown}
    >
      {renderTab(LIVE_TAB_ID, "live", `Live · ${liveCount}`)}
      {renderTab(OFF_TAB_ID, "offcamera", `Fulfillment · ${offCount}`)}
    </div>
  );
}

EventTabs.propTypes = {
  tab: PropTypes.oneOf(["live", "offcamera"]).isRequired,
  setTab: PropTypes.func.isRequired,
  liveCount: PropTypes.number.isRequired,
  offCount: PropTypes.number.isRequired,
};
